"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedLogo = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _setappLogo = _interopRequireDefault(require("./images/setapp-logo.svg"));
var _teamsSetappLogo = _interopRequireDefault(require("./images/teams-setapp-logo.svg"));
require("./animated-logo.scss");
var AnimatedLogo = exports.AnimatedLogo = function AnimatedLogo(_ref) {
  var animate = _ref.animate,
    hasCaption = _ref.hasCaption,
    withoutByMacPawCaption = _ref.withoutByMacPawCaption,
    inverse = _ref.inverse,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    forTeams = _ref.forTeams;
  var svgClasses = (0, _classnames["default"])('animated-logo', {
    'animated-logo_animate': animate,
    'animated-logo_without-caption': !hasCaption,
    'animated-logo_without-caption-by-macpaw': hasCaption && withoutByMacPawCaption && !forTeams,
    'animated-logo_inverse': inverse,
    'animated-logo_sm': size === 'sm'
  });
  var logImage = forTeams ? _teamsSetappLogo["default"] : _setappLogo["default"];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: svgClasses
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: logImage
  }));
};

// is only needed to avoid snapshots updating
AnimatedLogo.defaultProps = {
  size: 'md'
};